import React from 'react';
import * as conciliationService from '../../services/conciliation/Conciliation';

const ConciliationContext = React.createContext();
const { Provider, Consumer } = ConciliationContext;

class ConciliationProvider extends React.Component {
  state = {
    response: null,
  };

  constructor(props) {
    super(props);
    this.sendAssessmentRequest = this.sendAssessmentRequest.bind(this);
    this.conciliationRequest = this.conciliationRequest.bind(this);
    this.requestView = this.requestView.bind(this);
    this.view = this.view.bind(this);
  }

  async sendAssessmentRequest(data) {
    return new Promise(async (resolve, reject) => {
      await conciliationService
        .sendAssessmentRequest(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async conciliationRequest(data) {
    return new Promise(async (resolve, reject) => {
      await conciliationService
        .conciliationRequest(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async view(registrationNumber) {
    return new Promise(async (resolve, reject) => {
      await conciliationService
        .view(registrationNumber)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async requestView(id) {
    return new Promise(async (resolve, reject) => {
      await conciliationService
        .requestView(id)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  render() {
    const { children } = this.props;

    return (
      <Provider
        value={{
          response: this.state.response,
          sendAssessmentRequest: this.sendAssessmentRequest,
          conciliationRequest: this.conciliationRequest,
          requestView: this.requestView,
          view: this.view,
        }}
      >
        {children}
      </Provider>
    );
  }
}

export default ConciliationContext;

export { ConciliationProvider, Consumer };
